import { useState } from "react";
import { ImageOff } from "lucide-react";

const supportImageFilenameRe = /^[A-Za-z0-9][A-Za-z0-9_.-]{0,140}\.(jpe?g|png|webp|gif)$/i;

function validImageUrl(src) {
  const value = String(src || "").trim();
  return Boolean(
    value.startsWith("data:image/") ||
    value.startsWith("/api/support-images/") ||
    value.startsWith("http://") ||
    value.startsWith("https://"),
  );
}

function normalizeImageUrl(src) {
  const value = String(src || "").trim();
  if (!value || value === "__image__") return "";
  if (value.startsWith("data:image/") || value.startsWith("http://") || value.startsWith("https://")) return value;
  if (value.startsWith("/api/support-images/")) return value;
  if (value.startsWith("api/support-images/")) return `/${value}`;
  if (value.startsWith("/support-images/")) return `/api${value}`;
  if (!value.includes("/") && !value.includes("\\") && supportImageFilenameRe.test(value)) {
    return `/api/support-images/${encodeURIComponent(value)}`;
  }
  return value;
}

export default function ChatImageAttachment({
  src,
  name = "Attachment",
  onPreview,
  className = "block max-h-44 max-w-full rounded-xl object-contain",
}) {
  const [broken, setBroken] = useState(false);
  const imageSrc = normalizeImageUrl(src);
  if (!validImageUrl(imageSrc) || broken) {
    return (
      <div className="mb-2 flex max-w-full items-center gap-2 rounded-xl border border-white/10 bg-black/20 px-3 py-2 text-xs text-white/55">
        <ImageOff className="h-4 w-4 shrink-0" />
        <span className="min-w-0 truncate">{name || "Photo unavailable"}</span>
      </div>
    );
  }
  return (
    <button
      type="button"
      onClick={() => onPreview?.({ src: imageSrc, name })}
      className="mb-2 block max-w-full cursor-zoom-in rounded-xl bg-black/20 text-left outline-none ring-[#D4AF37]/60 focus:ring-2"
      aria-label="Open image preview"
    >
      <img
        src={imageSrc}
        alt={name}
        className={className}
        onError={() => setBroken(true)}
      />
    </button>
  );
}
